<template>
  <div :class="classes">
    <span v-if="hasSlot" :class="slotClasses"><slot></slot></span>
  </div>
</template>
<script>
const prefixCls = "k-divider";

export default {
  name: "k-divider",
  props: {
    type: {
      default: "horizontal",
      validator(val) {
        return ["horizontal", "vertical"].includes(val);
      }
    },
    orientation: {
      type: String,
      default: "center",
      validator(val) {
        return ["left", "right", "center"].includes(val);
      }
    },
    dashed: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasSlot() {
      return !!this.$slots.default;
    },
    classes() {
      return [
        `${prefixCls}`,
        `${prefixCls}-${this.type}`,
        {
          [`${prefixCls}-with-text`]:
            this.hasSlot && this.orientation === "center",
          [`${prefixCls}-with-text-${this.orientation}`]: this.hasSlot,
          [`${prefixCls}-dashed`]: !!this.dashed
        }
      ];
    },
    slotClasses() {
      return [`${prefixCls}-inner-text`];
    }
  }
};
</script>

<style lang="less">
@divider-prefix-cls: k-divider;
.@{divider-prefix-cls} {
  color: red;
  background-color: rgb(232, 234, 236);
  &,
  &-vertical {
    margin: 0 8px;
    display: inline-block;
    height: 0.9em;
    width: 1px;
    vertical-align: middle;
    position: relative;
    top: -0.06em;
  }
  &-horizontal {
    display: block;
    height: 1px;
    width: 100%;
    min-width: 100%;
    margin: 24px 0;
    clear: both;
  }

  &-horizontal&-with-text-center,
  &-horizontal&-with-text-left,
  &-horizontal&-with-text-right {
    display: table;
    white-space: nowrap;
    text-align: center;
    background: transparent;
    font-weight: 500;
    color: #333;
    font-size: 16px;
    margin: 16px 0;
    &:before,
    &:after {
      content: "";
      display: table-cell;
      position: relative;
      top: 50%;
      width: 50%;
      border-top: 1px solid rgb(232, 234, 236);
      transform: translateY(50%);
    }
  }
  &-horizontal&-with-text-left,
  &-horizontal&-with-text-right {
    .@{divider-prefix-cls}-inner-text {
      display: inline-block;
      padding: 0 10px;
    }
  }

  &-horizontal&-with-text-left {
    &:before {
      top: 50%;
      width: 5%;
    }
    &:after {
      top: 50%;
      width: 95%;
    }
  }

  &-horizontal&-with-text-right {
    &:before {
      top: 50%;
      width: 95%;
    }
    &:after {
      top: 50%;
      width: 5%;
    }
  }

  &-inner-text {
    display: inline-block;
    padding: 0 24px;
  }

  &-dashed {
    background: none;
    border-top: 1px dashed rgb(232, 234, 236);
  }
  &-horizontal&-with-text&-dashed,
  &-horizontal&-with-text-left&-dashed,
  &-horizontal&-with-text-right&-dashed {
    border-top: 0;
    &:before,
    &:after {
      border-style: dashed none none;
    }
  }
}
</style>
